import { createRouter, createWebHistory } from 'vue-router'
import Home from '../views/Home.vue'
import NasStorageProducts from '../views/product/NasStorageProducts.vue'
import NasStorageSoftware from '../views/product/NasStorageSoftware.vue'
import NasStorageHardwareDetail from '../views/product/NasStorageHardwareDetail.vue'
import AiPlatform from '../views/solutions/AiPlatform.vue'
import Sase from '../views/solutions/Sase.vue'
import EqualProtection from '../views/solutions/EqualProtection.vue'
import TrafficCompression from '../views/solutions/TrafficCompression.vue'
import DedicatedLineSecurity from '../views/solutions/DedicatedLineSecurity.vue'
import ResourcePool from '../views/solutions/ResourcePool.vue'
import LargeInstitutionInternetEgressSslo from '../views/solutions/LargeInstitutionInternetEgressSslo.vue'
import ZwyCompression from '../views/solutions/ZwyCompression.vue'
import PasswordCompression from '../views/solutions/PasswordCompression.vue'
import Storage from '../views/solutions/Storage.vue'
import EdgeInfrastructureSolutionTemplate from '../views/solutions/EdgeInfrastructureSolutionTemplate.vue'
import AiApplicationSolutionTemplate from '../views/solutions/AiApplicationSolutionTemplate.vue'
import XinchuangTopic from '../views/solutions/XinchuangTopic.vue'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: { title: '首页' }
  },
  {
    path: '/product/storage',
    name: 'StorageProducts',
    component: NasStorageProducts,
    meta: { title: '存储产品' }
  },
  {
    path: '/product/storage/software',
    name: 'NasStorageSoftware',
    component: NasStorageSoftware,
    meta: { title: '芯存 XNAS 软件' }
  },
  {
    path: '/product/storage/:slug',
    name: 'NasStorageHardwareDetail',
    component: NasStorageHardwareDetail,
    meta: { title: '存储产品' }
  },
  {
    path: '/product/:slug(.*)',
    name: 'ProductDetail',
    component: () => import('../views/product/ProductDetail.vue'),
    meta: { title: '产品详情' }
  },
  {
    path: '/solutions/ai-platform',
    name: 'AiPlatformSolution',
    component: AiPlatform,
    meta: { title: 'AI 算力平台解决方案', solutionKey: 'ai-platform' },
  },
  {
    path: '/solutions/ai-native-platform',
    name: 'AiNativePlatformSolution',
    component: AiPlatform,
    meta: { title: 'AI native 平台解决方案', solutionKey: 'ai-native-platform' },
  },
  {
    path: '/solutions/comprehensive-xinchuang',
    name: 'ComprehensiveXinchuangSolution',
    component: XinchuangTopic,
  },
  {
    path: '/solutions/ai-infrastructure-solution',
    name: 'AiInfrastructureSolution',
    component: EdgeInfrastructureSolutionTemplate,
    meta: { solutionKey: 'ai-infrastructure' },
  },
  {
    path: '/solutions/sase',
    name: 'SaseSolution',
    component: Sase,
    alias: ['/solutions/sase-security-solution'],
  },
  {
    path: '/solutions/equal-protection',
    name: 'EqualProtection',
    component: EqualProtection,
    alias: ['/solutions/low-cost-security-for-small-and-medium-systems'],
  },
  {
    path: '/solutions/traffic-compression',
    name: 'TrafficCompression',
    component: TrafficCompression,
  },
  {
    path: '/solutions/storage',
    name: 'StorageSolution',
    component: Storage,
  },
  {
    path: '/solutions/password',
    name: 'PasswordCompression',
    component: PasswordCompression,
  },
  {
    path: '/solutions/zwy',
    name: 'zwySolution',
    component: ZwyCompression,
    alias: ['/solutions/industry-government-cloud-security'],
  },
  {
    path: '/solutions/resource-pool',
    name: 'ResourcePool',
    component: ResourcePool,
    alias: ['/solutions/private-cloud-security'],
  },
  {
    path: '/solutions/large-institution-internet-egress-sslo',
    name: 'LargeInstitutionInternetEgressSslo',
    component: LargeInstitutionInternetEgressSslo,
  },
  {
    path: '/solutions/server-virtualization',
    name: 'ServerVirtualizationSolution',
    component: EdgeInfrastructureSolutionTemplate,
    meta: { solutionKey: 'server-virtualization' },
  },
  {
    path: '/solutions/edge-computing',
    name: 'EdgeComputingSolution',
    component: EdgeInfrastructureSolutionTemplate,
    meta: { solutionKey: 'edge-computing' },
  },
  {
    path: '/solutions/vm-container-fusion-infrastructure',
    name: 'VmContainerFusionInfrastructureSolution',
    component: EdgeInfrastructureSolutionTemplate,
    meta: { solutionKey: 'vm-container-fusion' },
  },
  {
    path: '/solutions/database-cloud-infrastructure',
    name: 'DatabaseCloudInfrastructureSolution',
    component: EdgeInfrastructureSolutionTemplate,
    meta: { solutionKey: 'database-cloud' },
  },
  {
    path: '/solutions/compute-network-infrastructure',
    name: 'ComputeNetworkInfrastructureSolution',
    component: EdgeInfrastructureSolutionTemplate,
    meta: { solutionKey: 'compute-network-infrastructure' },
  },
  {
    path: '/solutions/ai-threat-intel',
    name: 'AiThreatIntelSolution',
    component: AiApplicationSolutionTemplate,
    meta: { solutionKey: 'ai-threat-intel' },
  },
  {
    path: '/solutions/cloud-edge-model-collaboration',
    name: 'CloudEdgeModelCollaborationSolution',
    component: AiApplicationSolutionTemplate,
    meta: { solutionKey: 'cloud-edge-model-collaboration' },
  },
  {
    path: '/solutions/edge-cv-security',
    name: 'EdgeCvSecuritySolution',
    component: AiApplicationSolutionTemplate,
    meta: { solutionKey: 'edge-cv-security' },
  },
  {
    path: '/solutions/vehicle-ai-offense-defense-range',
    name: 'VehicleAiOffenseDefenseRangeSolution',
    component: AiApplicationSolutionTemplate,
    meta: { solutionKey: 'vehicle-ai-offense-defense-range' },
  },
  {
    path: '/solutions/dedicated-line-security',
    name: 'DedicatedLineSecurity',
    component: DedicatedLineSecurity,
    alias: ['/solutions/carrier-dedicated-line-security'],
  },
  {
    path: '/about-us',
    name: 'About',
    component: () => import('../views/About.vue'),
    alias: ['/about'],
    meta: { title: '了解瑞和云图' }
  },
  {
    path: '/success-cases',
    redirect: { path: '/', hash: '#success-cases' }
  },
  {
    path: '/compute-tower',
    name: 'ComputeTowerDeck',
    component: () => import('../views/ComputeTowerDeck.vue'),
    meta: { title: 'Compute Tower · 算网安智一体化运营平台' }
  },
  {
    path: '/contact',
    name: 'Contact',
    component: () => import('../views/Contact.vue'),
    meta: { title: '联系我们' }
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      return new Promise((resolve) => {
        setTimeout(() => {
          resolve({ el: to.hash, behavior: 'smooth' })
        }, 80)
      })
    }
    if (savedPosition) return savedPosition
    return { top: 0 }
  }
})

router.beforeEach((to, from, next) => {
  // 动态设置页面标题
  if (to.name === 'SolutionDetail' && to.params.slug) {
    // 解决方案详情页 - 动态标题
    import('../data/solutionsData.js').then(({ getSolutionBySlug }) => {
      const solution = getSolutionBySlug(to.params.slug)
      if (solution) {
        document.title = `${solution.title} | 瑞和云图`
      } else {
        document.title = '解决方案详情 | 瑞和云图'
      }
    })
  } else if (to.name === 'ProductDetail' && to.params.slug) {
    // 产品详情页 - 动态标题
    import('../data/searchData.js').then(({ searchData }) => {
      const product = searchData.products.find(p => p.id === to.params.slug)
      if (product) {
        document.title = `${product.name} | 瑞和云图`
      } else {
        document.title = '产品详情 | 瑞和云图'
      }
    })
  } else {
    const title = to.meta.title
    if (title) {
      document.title = `${title} | 瑞和云图`
    }
  }
  next()
})

// 动态设置产品详情页标题
router.afterEach((to) => {
  if (to.name === 'ProductDetail' && to.params.slug) {
    // 延迟设置，等待组件加载数据
    setTimeout(() => {
      const productTitle = document.querySelector('.product-title')
      if (productTitle) {
        document.title = `${productTitle.textContent} | 瑞和云图`
      }
    }, 100)
  }
})

export default router
